import { render, staticRenderFns } from "./HandlerPage.vue?vue&type=template&id=09e99648"
import script from "./HandlerPage.vue?vue&type=script&lang=js"
export * from "./HandlerPage.vue?vue&type=script&lang=js"
import style0 from "./HandlerPage.vue?vue&type=style&index=0&id=09e99648&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports